import { Box, Stack, Typography } from "@mui/material";

export default function AdStateChip({ adState }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: "100%", height: "100%" }}
    >
      <Box
        sx={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: bgColor(adState),
        }}
      ></Box>
      <Typography
        sx={{
          fontSize: "12px",
          color: "#00000099",
          fontWeight: 500,
          lineHeight: "14px",
        }}
      >
        {adState}
      </Typography>
    </Stack>
  );
}

const bgColor = (adState) => {
  switch (adState) {
    case "NPI":
      return "#8BC34A";
    case "Early Stage":
      return "#FFEB3B";
    case "High Growth":
      return "#03A9F4";
    case "Profiatabe Core":
      return "#9C27B0";
    case "Exit":
      return "#F44336";
    default:
      return "#000000DE";
  }
};
